<template>
    <div class="c-schedule-header"
        :data-component-name="$options.name"
    >
            <!-- <pre>{{ weekmonths }}</pre> -->
        <div class="c-schedule-row -hidden-mobile">
            <div class="c-schedule__control -left">
                <RangePicker
                    v-model="weekrange.str"
                    @set-current-date="$emit('set-current-date', $event)"
                />
            </div>
            <div class="c-schedule__month-wrap">
                <div
                    v-bind:key="index" v-for="(weekmonth, index) in weekmonths"
                    :style="'width:'+(100/7*weekmonth.ctr)+'%'"
                    class="c-schedule__month"
                >
                {{ weekmonth.str }}
                </div>
            </div>
            <div class="c-schedule__control -right">
                <RangePicker
                    v-model="weekrange.str"
                    @set-current-date="$emit('set-current-date', $event)"
                />
            </div>
        </div>
        <div class="c-schedule-row">
            <div class="c-schedule__control -left">
                <button
                    class="-previous-week -hidden-mobile"
                    @click="$emit('set-current-date', prevWeek)"
                >
                    <SvgIcon name="arrow-alt-left" />
                </button>
                <RangePicker
                    class="-hidden-desktop"
                    v-model="accurateWeekRange.str"
                    @set-current-date="$emit('set-current-date', $event)"
                />
            </div>
            <div class="c-schedule__control -right  -hidden-mobile">
                <button
                    class="-next-week"
                    @click="$emit('set-current-date', nextWeek)"
                >
                    <SvgIcon name="arrow-alt-right" />
                </button>
            </div>

            <!-- <div class="c-schedule-cols"
                @scroll.passive="$emit('scroll-passive', $event)"
                ref="headerScroll"
            >
				<div class="c-schedule-col -scrollableX"
	                v-bind:key="index" v-for="(weekday, index) in weekdays"
	            > -->
            <div class="c-schedule-cols"
                ref="headerScroll"
            >
				<div class="c-schedule-col"
	                v-bind:key="index" v-for="(weekday, index) in weekdays"
	            >
	                <div class="c-schedule__day">
	                    {{ weekday.dayOfWeekStr.full }} <strong>{{ weekday.day }} <span class="-hidden-desktop">{{ weekday.monthStr.full.toLowerCase() }}</span></strong> <span class="-hidden-desktop">{{ weekday.date.getFullYear() }}</span>
	                </div>
	            </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getWeeksLimits, getDatesBetween, dayOfWeekStr, monthStr, dayStr} from "@/js/dateUtilities"
    import moment from 'moment';

    export default{
        name: 'ScheduleHeader.vue',
        props: {
            currentDate: String,
            weekrange: Object
        },
        data(){
            return {
                dateOffset: parseInt(this.$generalSettings.settings.firstDayOfWeek)+0,
                accurateWeekRange: {}
            }
        },
        mounted(){
            this.accurateWeekRange=getWeeksLimits(this.currentDate, this.$generalSettings.settings.firstDayOfWeek);
            document.onkeydown = function(e){
                if (e.keyCode == 37 && e.altKey && e.ctrlKey && !e.shiftKey) this.$emit('set-current-date', this.prevWeek)
                if (e.keyCode == 39 && e.altKey && e.ctrlKey && !e.shiftKey) this.$emit('set-current-date', this.nextWeek)
            }.bind(this)
        },
        beforeDestroy() {
            document.onkeydown = null
        },
        watch: {
            currentDate: function(){
                this.accurateWeekRange=getWeeksLimits(this.currentDate, this.$generalSettings.settings.firstDayOfWeek);
            }
        },
        computed: {
            prevWeek(){
                return moment(this.currentDate).subtract(7, 'days').format('YYYY-MM-DD');
            },
            nextWeek(){
                return moment(this.currentDate).add(7, 'days').format('YYYY-MM-DD');
            },
            weekdays(){
                let dateRange=getDatesBetween(this.weekrange.obj.from, this.weekrange.obj.to)
                let weekdays=[]

                dateRange.forEach(function(date){
                    weekdays.push({
                        date: date,
                        day: dayStr(date.getDate()),
                        dayOfWeekStr: dayOfWeekStr(date),
                        monthStr: monthStr(date)
                    })
                })
                return weekdays
            },
            weekmonths(){
                let weekmonths=[], prevMonth=-1, month={};
                this.weekdays.forEach(function(day){
                    if(prevMonth!=day.monthStr.month){
                        month={}
                        month.str=day.monthStr.full + ' ' + day.date.getFullYear();
                        month.ctr=0;
                        weekmonths.push(month);
                    }
                    month.ctr++;
                    prevMonth=day.monthStr.month;
                }.bind(this))

                return weekmonths;
            }
            // firstDayOfweek(){
            //     if(this.currentDate) return moment(this.currentDate).startOf('week');

            //     return 'asdasd';
            // }
        }
    }
</script>
